import { render, staticRenderFns } from "./LinkPacientePtiVisibleComponenteV5.vue?vue&type=template&id=6f8408f2&scoped=true"
import script from "./LinkPacientePtiVisibleComponenteV5.vue?vue&type=script&lang=js"
export * from "./LinkPacientePtiVisibleComponenteV5.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8408f2",
  null
  
)

export default component.exports